
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  getStayRoomSpecialPrice,
  addStayRoomSpecialPrice,
  updateStayRoomSpecialPrice,
} from '@/api/stayRoomSpeicalPrice';
import { ElForm } from 'element-ui/types/form';
import { getStayRoomPricePerDay } from '@/api/stayRoomPrice';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) private formIdx!: any;

  @Prop({ required: true }) private roomList!: any;

  mounted() {
    this.init();
  }

  private loading = true;

  private formData = {
    roomIdx: null,
    targetDate: '',
    reason: '',
    price: 0,
    discountViewStatus: true,
  }

  private roomOriginPrice = 0;

  private rules = {
    roomIdx: [
      { required: true, message: '객실을 선택해 주세요.', trigger: ['blur', 'change'] },
    ],
    targetDate: [
      { required: true, message: '지정일을 입력해 주세요.', trigger: ['blur', 'change'] },
    ],
  }

  private init() {
    if (this.formIdx) {
      getStayRoomSpecialPrice(this.formIdx).then((res) => {
        this.loading = false;
        this.formData = res.data;
        this.getRoomPrice();
      });
    } else {
      this.loading = false;
    }
  }

  private handleClickSave() {
    (this.$refs.formRef as ElForm).validate((valid: boolean) => {
      if (valid) {
        if (this.formIdx) {
          updateStayRoomSpecialPrice(this.formIdx, this.formData).then(() => {
            this.$message.success('특가 설정이 수정되었습니다.');
            this.$emit('save');
          });
        } else {
          addStayRoomSpecialPrice(this.formData).then(() => {
            this.$message.success('특가 설정이 추가되었습니다.');
            this.$emit('save');
          });
        }
      }
    });
  }

  private getRoomPrice() {
    if (this.formData.roomIdx && this.formData.targetDate) {
      getStayRoomPricePerDay(this.formData.roomIdx, this.formData.targetDate).then((res) => {
        this.roomOriginPrice = res.data;
      });
    }
  }
}
